<template>

  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>Administratie</b-breadcrumb-item>
      <b-breadcrumb-item to="/main/admin/printers" active>Printers</b-breadcrumb-item>
    </b-breadcrumb>

    <h2>Printers</h2>

    <table-wrap :fields="$options.fields" small striped :query="$options.query" :per-page="$store.state.perPage" table-class="printer-list" hover
      :state.sync="state" :reset-state="$store.state.resetPrintersView" selectable @row-selected="rowSelected">

      <template #cell(selected)="data">
        <b-form-checkbox :checked="data.rowSelected"/>
      </template>
      
      <template #cell(ink)="{item: {c, m, y, k, w2}}">
        <div class="ink-status text-nowrap">
          <span v-if="c[0]" :class="{'blink-me': c[0].value < 25}"><span class="mdi mdi-water c" />{{c[0].value}}%</span>
          <span v-if="m[0]" :class="{'blink-me': m[0].value < 25}"><span class="mdi mdi-water m" />{{m[0].value}}%</span>
          <span v-if="y[0]" :class="{'blink-me': y[0].value < 25}"><span class="mdi mdi-water y" />{{y[0].value}}%</span>
          <span v-if="k[0]" :class="{'blink-me': k[0].value < 25}"><span class="mdi mdi-water k" />{{k[0].value}}%</span>
          <span v-if="w2[0] && w2[0].value === 1"><span class="mdi mdi-flask-outline"/>OK</span>
          <span v-if="w2[0] && w2[0].value === 0" class="blink-me"><span class="mdi mdi-flask-outline" />ATTN</span>
        </div>
      </template>

      <template v-slot:cell(device)="{item}">
        <template v-if="item.device === null">
          <span class="text-muted font-italic">Nog niet detecteerd</span>
        </template>
        <template v-else>
          <router-link :to="`/main/admin/bigfox/view/${item.device.id}`">{{item.device.displayName}} <small>{{item.device.serial}}</small></router-link>
        </template>
      </template>

      <template v-slot:cell(contracts)="{item: {contractPrinters: { nodes }}}">
        <template v-if="nodes.length === 0">
          <span class="text-muted font-italic">Niet toegewezen aan een contract</span>
        </template>
        <template v-else>
          <router-link :to="`/main/admin/contracts/view/${nodes[0].contract.id}`">{{nodes[0].contract.name}}</router-link>
          <span class="text-muted ml-1">{{nodes[0].contract.customer.name}}</span>
        </template>
      </template>

      <template #cell(description)="{item: {contractPrinters: { nodes }}}">
        <template v-if="nodes.length === 0">
          <span class="text-muted font-italic">Niet toegewezen aan een contract</span>
        </template>
        <template v-else>
          {{nodes[0].brand}} {{nodes[0].name}} {{nodes[0].location}}
        </template>
      </template>

      <template v-slot:cell(actions)="row">
        <b-dropdown variant="primary" text="Meer" size="sm" right>
          <b-dropdown-item variant="primary" @click="editPrinterId = row.item.id"><span class="mdi mdi-pencil"/> Bewerken</b-dropdown-item>
          <b-dropdown-item variant="danger" @click="deletePrinter(row)"><span class="mdi mdi-trash-can-outline"/> Verwijderen</b-dropdown-item>
        </b-dropdown>
        <b-btn variant="primary" size="sm" :to="`/main/admin/printers/view/${row.item.id}`" class="ml-1"><span class="mdi mdi-eye-outline"/>  Bekijken</b-btn>
        
      </template>

      <template #custom-foot>
        <b-tr>
          <b-td class="text-left pl-2" colspan="10">
            <b-icon icon="arrow-return-right"/>
            <b-btn class="ml-1" size="sm" @click="showMassUpdate = !showMassUpdate"><span class="mdi mdi-pencil"/> Bewerken</b-btn></b-td>
        </b-tr>
      </template>
    </table-wrap>

    <EditPrinterModal v-model="showEditPrinter" :id="editPrinterId"></EditPrinterModal>

    <b-modal title="Mass update" v-model="showMassUpdate" centered>
      <mass-update-printer ref="massPrinter" :ids="selectedPrinters.map(({id}) => id)" />
      <template v-slot:modal-footer="{ok, cancel}">
        <b-btn @click="cancel">Annuleer</b-btn>
        <b-btn @click="$refs.massPrinter.save(ok)" variant="primary">Opslaan</b-btn>
      </template>
    </b-modal>

  </div>


</template>

<script>

import actionField from '../../lib/actionField';
import { mapState} from 'vuex';
import TableWrap from '../../components/TableWrap';
import vuex_computed from '@/lib/vuex_computed';
import {M_UPDATE_PRINTERS_VIEW} from '@/lib/constants';
import EditPrinterModal from '@/components/EditPrinterModal';
import delModalShow from '@/lib/delModalShow';
import MassUpdatePrinter from '@/components/MassUpdatePrinter';

export default
{
    components: { EditPrinterModal, TableWrap, MassUpdatePrinter },
    computed:
    {
        ...mapState(['perPage']),
        state: vuex_computed('printersView', M_UPDATE_PRINTERS_VIEW),
        showEditPrinter: delModalShow('editPrinterId')
    },
    data()
    {
        return {
            editPrinterId: null,
            selectedPrinters: [],
            showMassUpdate: false
        }
    },
    methods:
    {
        async deletePrinter(row)
        {
            const response = await this.$bvModal.msgBoxConfirm('Ben je zeker dat je dit wil verwijderen?',
                {
                    title: 'Printer verwijderen',
                    okTitle: 'Verwijder',
                    okVariant: 'danger',
                    centered: true,
                    cancelTitle: 'Niet verwijderen',
                    cancelVariant: 'info',
                    titleClass: 'font-weight-bold'
                }
            );

            if(!response)
                return;

            return this.$apollo.mutate(
                {
                    mutation: require('../../graphql/mutation/delete_printer.gql'),
                    variables: { id: row.item.id }
                }
            );
        },
        rowSelected(selection)
        {
            this.selectedPrinters = selection;
        }
    },
    fields:
    [
        {
            key: 'selected',
            label: '',
            tdClass: 'p-1',
            selectAll: true,
            thClass: 'p-0'
        },
        {
            key: 'model.brand.name',
            label: 'Merk',
            search: 'STRING',
            thStyle: 'width: 11em',
        },
        {
            key: 'model.name',
            label: 'Model',
            search: 'STRING',
            thStyle: 'width: 16em'
        },
        {
            key: 'serial',
            label: 'Serienummer',
            search: 'STRING',
            thStyle: 'width: 10em'
        },
        {
            key: 'ink',
            label: 'Inkt/Toner',
        },
        {
            key: 'contracts',
            /*search: String,
            searchPath: 'contract.contractId'*/
            label: 'Contract',
            search: 'STRING',
            searchPath: 'contractPrinters.every.contract.name'
        },
        {
            key: 'description',
            label: 'Beschrijving contract'
        },
        {
            key: 'device',
            label: 'Gedetecteerd door'
        },
        actionField
    ],
    query: require('../../graphql/listPrinters.sub.gql')
}
</script>

<style>
table.printer-list thead th:nth-child(1) { width: 20px !important; } /* Selected checkbox */
</style>